import GeneralModel from './GeneralModel';
import mainAPI from "../api/MainAPI";
import objUtils from "../utils/objUtils";

export default class UnitModel extends GeneralModel {
	constructor(socket) {
		super('unit', socket, async ()  => await mainAPI.unit.all({archived: true}));
	}
}



// WEBPACK FOOTER //
// ./src/model/UnitModel.js